var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-toolbar',{attrs:{"color":"primary","dark":""}},[_c('v-toolbar-title',[_vm._v("Suppliers")]),_c('v-spacer'),_c('v-icon',[_vm._v("mdi-account-group")])],1),_c('v-data-table',{attrs:{"items":_vm.splrList,"headers":_vm.headers}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }